"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const Colors_1 = __importDefault(require("../../assets/colors/Colors"));
const LoadingView = ({ style, color = Colors_1.default.secondaryColor, indicatorStyle, size = 'small', }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_native_1.View, { style: [styles.container, style] },
            react_1.default.createElement(react_native_1.ActivityIndicator, { size: size, color: color, style: [styles.indicatorDefault, indicatorStyle] }))));
};
exports.default = LoadingView;
const styles = react_native_1.StyleSheet.create({
    container: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: Colors_1.default.white,
    },
    indicatorDefault: {},
});
